export const setSession = (key: string, value: any = {}): void => {
    if (!key) return;
    sessionStorage.setItem(key, JSON.stringify(value));
};

export const getSession = (key: string): any | null => {
    if (!key) return null; // Return null explicitly if key is missing
    const item = sessionStorage.getItem(key);
    return item ? JSON.parse(item) : null;
};

export const setLocal = (key: string, value: any = {}): void => {
    if (!key) return;
    localStorage.setItem(key, JSON.stringify(value));
};

export const getLocal = (key: string): any | null => {
    if (!key) return null; // Return null explicitly if key is missing
    const item = localStorage.getItem(key);
    return item ? JSON.parse(item) : null;
};
